module.exports = __webpack_public_path__ + "static/img/icon_scan.e8cdc5ed.png";